import axios from '../request/http.js'

class User {
  /* 一级，二级和模块登录 */
  static login(code, type) {
    const url = `/zzd/api/back/login/system/admin?code=${code}&type=${type}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default User;